<template>
  <div>
    <multiselect-searchbox-modal
        ref="multiselectSearchboxModalRef"
        :search-function="searchFunction"
        :selected-ids="selectedIds"
        :show-ids="showId"
        :disabled="disabled"
        :hide-multi-selection="hideMultiSelection"
        @selection-complete="onListSelection"
    />
    <div class="field_left">
      <div class="field field_search multiselect" :class="{disabled: disabled,extended:showExtended}" tabindex="0">
        <label :for="name+'_id'">
          <slot/>
        </label>
        <input
            :id="name+'_id'"
            class="search clearable"
            :name="name"
            autocomplete="off"
            size="30"
            v-model="inputText"
            type="text"
            @focus="initSearch()"
            @input="onSearch"
            @blur.stop.prevent="onFocusOut"
            :disabled="disabled"
        />
        <a :style="clrBtnStyle" class="clearable_btn" title="Vymazat text" @click="initSearch()" v-if="!disabled"><translate>Vymazat</translate></a>
        <div class="extended_search" :class="{extended:showExtended}">
          <ul v-if="filteredSelectableItems.length">
            <li v-if="showSelectAll"><a @mousedown.prevent.stop="selectAll()"><strong><translate>Vybrat vše</translate></strong></a></li>
            <li v-for="item in filteredSelectableItems"><a @mousedown.prevent="selectItem(item.id, item)">
              <span class="item_id" v-if="showId" v-html="highlightSearchedText(item.id)"></span>
              <span class="item_label" v-html="highlightSearchedText(item.text)"></span>
            </a>
            </li>
          </ul>
          <ul v-else>
            <li v-if="!hideMultiSelection"><translate>Nic nenalezeno</translate></li>
            <li v-else><translate>Zadejte vyhledávací řetězec</translate></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="field_right">
      <ul class="selected_results">
        <li v-if="showRemoveAll" class="delete_all" @click="removeAll">
          <a class="close" v-translate>Odstranit vše</a>
        </li>
        <li v-for="id in filteredSelectedIds" :class="{'disabled': !isIdEditable(id)}">
          <span><a class="close" @click="removeItem(id)" v-translate>Odstranit</a></span>
          <span v-if="showId" class="item_id">{{id}} </span>
          <span>{{getText(id)}}</span>
          <span v-if="settingsSlotIsSet && isIdEditable(id)" @click.prevent.stop="clickCallbackFunction(id)">
            <slot name="settings"></slot>
          </span>
        </li>
        <li v-if="showShowMoreButton" class="view_all" @click="onShowMoreButtonClick"><a v-translate>Specifikovat</a></li>
      </ul>
    </div>
  </div>
</template>

<script>
import { highlightText } from '../../utils/helpers';
import { useSlots } from 'vue'
import multiselectSearchboxModal from "./MultiselectSearchboxModal";

export default {
  name: "MultiselectSearchbox",
  components: {
    multiselectSearchboxModal
  },
  props:{
    value: Array,
    searchFunction: Function,
    clickCallbackFunction: Function,
    onAddCallbackFunction: Function,
    showId: Boolean,
    disabled: Boolean,
    defaultData: Object,
    hideMultiSelection: Boolean,
    hideRemoveAll: Boolean,
    nonEditableIds: Array,
    operatorsOnly: Boolean,
    onlyOne: Boolean,
    name: {
      type: String,
      default: "inputText"
    },
    stringIds: {
      type: Boolean,
      default: false,
    }
  },
  data(){
    return {
      inputText: '',
      showExtended: false,
      selectableItems: [],
      selectedDataObject: {},
      searchItemLimit: 15,
      showSelectedLimit: 5,
      selectedIds: [],
      defaultDataLoaded: false,
      disableSelectedLimit: false,
      inicialized: false,
      keyPressTimeoutMiliseconds: 500,
      keyTimer: null,
    }
  },
  created() {
    if(this.value && this.value.length){
      this.selectedIds = this.value;
      if(this.defaultData && Object.keys(this.defaultData).length === this.selectedIds.length){
        this.selectedDataObject = this.defaultData;
        this.defaultDataLoaded = true;
      }
    }
  },
  computed: {
    settingsSlotIsSet() {
      return useSlots().settings
    },
    selectedData: {
      get() {
        if (this.selectedIds.length !== Object.keys(this.selectedDataObject).length && !this.defaultDataLoaded && !this.inicialized) {
          this.searchFunction('', !this.hideMultiSelection, true, false, this.selectedIds)
              .then(data => {
                let loadedData = {};
                data['data'].forEach(item => {
                  if(!this.stringIds){
                    if (this.selectedIds.map(Number).includes(Number(item.id))) {
                      loadedData[item.id] = item;
                    }
                  }else{
                    if (this.selectedIds.includes(item.id)) {
                      loadedData[item.id] = item;
                    }
                  }
                  this.selectedDataObject = loadedData;
                  this.inicialized = true;
                });
              });
          }
          return this.selectedDataObject;
      },
      set(value) {
        this.selectedDataObject = value;
      }
    },
    showSelectAll(){
      return !this.inputText.length && this.filteredSelectableItems.length && !this.hideMultiSelection && !this.onlyOne;
    },
    showRemoveAll(){
      return this.selectedIds.length > 1 && !this.disabled && !this.hideRemoveAll
    },
    filteredSelectableItems(){
      if(this.selectableItems) {
        let filteredIds = this.selectableItems.filter(item => !this.selectedIds.includes(item.id));
        return filteredIds.slice(0, this.searchItemLimit);
      }else{
        return [];
      }
    },
    filteredSelectedIds(){
      return this.disableSelectedLimit ? this.selectedIds : this.selectedIds.slice(0, this.showSelectedLimit);
    },
    clrBtnStyle() {
      return this.inputText === '' ? 'display: none' : 'display: inline';
    },
    inputStyle(){
      return this.showExtended ? 'z-index: 10': 'z-index: 3';
    },
    extendedStyle(){
      return this.showExtended ? 'z-index: 11': 'z-index: 1';
    },
    showShowMoreButton(){
      return this.selectedIds.length > this.showSelectedLimit && !this.disableSelectedLimit;
    }
  },
  methods: {
    isIdEditable(id){
      return !(this.disabled || (this.nonEditableIds && this.nonEditableIds.includes(id)))
    },
    getText(id){
      if(this.selectedData.hasOwnProperty(id)){
        return this.selectedData[id].text;
      }else{
        return "";
      }
    },
    initSearch(){
      this.showExtended = true;
      this.inputText = '';
      this.searchFunction('', false, false, this.operatorsOnly)
          .then(data => {
            this.selectableItems = data['data'];
          });
    },
    onFocusOut(){
      this.showExtended = false;
      this.inputText = '';
    },
    onSearch(){
      clearTimeout(this.keyTimer);
      this.keyTimer = setTimeout(this._search, this.keyPressTimeoutMiliseconds);
    },
    _search(){
      this.searchFunction(this.inputText, false, false, this.operatorsOnly)
          .then(data => {
            this.selectableItems = data['data'];
            })
          .then(() => {
            // set visual width of ID PART
            $('.extended_search').each(function() {
              var longestWidth = 0;

              $(this).find('.item_id').each(function() {
                var width = $(this).width();
                if (width > longestWidth) {
                  longestWidth = width;
                }
              });

              $(this).find('.item_id').width(longestWidth);
            });
            // -- END --
          });
    },
    highlightSearchedText(text){
      return highlightText(text, this.inputText, '<span class="highlight">', '</span>');
    },
    selectItem(id, data){
      if(!this.isIdEditable(id)){
        return;
      }
      let tmpSelectedIDs = [...this.selectedIds];
      tmpSelectedIDs.push(id);
      if(this.onlyOne && tmpSelectedIDs.length > 0){
        tmpSelectedIDs = [tmpSelectedIDs[tmpSelectedIDs.length -1]];
      }
      this.selectedIds = tmpSelectedIDs;
      let tmpSelectedData = this.selectedData;
      tmpSelectedData[id] = data;
      this.selectedData = tmpSelectedData;
      this.handleInput();
      if(this.onAddCallbackFunction){
        this.onAddCallbackFunction(id);
      }
    },
    selectAll(){
      if(this.disabled){
        return;
      }
      let ids = [];
      let itemData = {};
      this.searchFunction('', !this.hideMultiSelection, false, this.operatorsOnly)
          .then(data => {
            data['data'].forEach(item => {
              ids.push(item.id);
              itemData[item.id] = item;
            })
            this.onFocusOut();
            this.selectedIds = ids;
            this.selectedData = itemData;
            this.handleInput();
          });
    },
    removeItem(itemId){
      if(!this.isIdEditable(itemId)){
        return;
      }
      this.selectedIds = this.selectedIds.filter(id => id !== itemId);
      let tmpSelectedData = this.selectedData;
      delete tmpSelectedData[itemId];
      this.selectedData = tmpSelectedData;
      if(this.selectedIds.length < this.showSelectedLimit){
        this.disableSelectedLimit = false;
      }
      this.handleInput();
    },
    removeAll(){
      if(this.disabled){
        return;
      }
      this.selectedIds = [];
      this.selectedData = {};
      this.disableSelectedLimit = false;
      this.handleInput();
    },
    onListSelection(ids, data){
      this.selectedIds = ids;
      this.selectedData = data;
      this.handleInput();
    },
    onShowMoreButtonClick(){
      if(this.hideMultiSelection){
        this.disableSelectedLimit = true;
      }else {
        this.$refs.multiselectSearchboxModalRef.showModal(true)
      }
    },
    handleInput(){
      this.$emit('input', this.selectedIds)
    }
  },
  watch: {
    value(){
      this.selectedIds = this.value;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/MultiselectSearchbox.vue